module.exports = __webpack_public_path__ + "static/media/YM74_4.fef48db3.jpg";